export default __webpack_public_path__ + "304c9d3583ef209df42e2461c696d88e.png";